var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mb-3"},[_c('div',{staticClass:"card-body p-3"},[_c('div',{staticClass:"chart"},[_c('canvas',{ref:"chartCanvas",staticClass:"chart-canvas",attrs:{"id":"productos","height":"100px"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }